import { Component, OnInit } from '@angular/core';
import { latLng, LatLng, tileLayer, marker, icon} from 'leaflet';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-stores',
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.scss'],
})
export class StoresComponent implements OnInit {
  options = {
    layers: [
      tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }),
    ],
    zoom: 6,
    center: latLng(46.52863469527167, 2.43896484375),
  };

  markerClusterData: any[] = [];
  filteredData: any[] = [];

  showSearch = false;

  searchInput: string;

  constructor(private api: ApiService) {}

  stores;

  ngOnInit() {
    if (this.api.inIframe()) {
      document.getElementById('header').style.display = 'none';
      document.getElementById('footer').style.display = 'none';

      document.getElementById('main').style.minHeight = 'auto';
      document.getElementById('main').classList.remove('p-4');
      document
        .getElementById('map-container')
        .classList.remove('-ml-4', '-mr-4', '-mt-2');
      document.body.style.minHeight = 'auto';
      document.body.style.background = 'white';
      document.body.style.overflow = 'hidden';
      let w = document.getElementById('map-container').clientWidth * 0.75;
      document.getElementById('map').style.height = w + 'px';
      window.parent.postMessage({ height: w, footerHeight: 0 }, '*');
    }
    const data: any[] = [];
    this.api.post('site=getStores', { active: true }).then((res: any) => {
      this.stores = res['stores'];
      for (let el of this.stores) {
        let template = "<h3 class='m-0 text-200'>" + el.Name + '</h3>';
        if (el.address_geo != null) {
          template +=
            "<div style='white-space: pre;'>" + el.address_geo + '</div>';
        } else {
          template +=
            '<div>' +
            el.MainDeliveryAddress_Address1 +
            '</div><div>' +
            el.MainDeliveryAddress_Address2 +
            '</div><div>' +
            el.MainDeliveryAddress_Address3 +
            '</div><div>' +
            el.MainDeliveryAddress_ZipCode +
            ' ' +
            el.MainDeliveryAddress_City +
            '</div><div>' +
            (el.MainDeliveryContact_Phone || el.MainDeliveryContact_CellPhone) +
            '</div><div>' +
            (el.MainDeliveryAddress_WebSite ||
              el.MainInvoicingAddress_WebSite) +
            '</div><div>';
        }
        template = template.replace(/null/gm, '');
        data.push(
          marker([el.latitude, el.longitude], {
            icon: icon({
              iconSize: [24, 41],
              iconUrl: '/assets/marker-icon-blue.png',
            }),
          }).bindPopup(template)
        );
      }
      this.markerClusterData = this.filteredData = data;
    });
  }

  search() {
    this.showSearch = !this.showSearch;
    if (this.searchInput && this.searchInput != '') {
      this.filteredData = this.markerClusterData.filter((item) => {
        return (
          item._popup._content
            .toLowerCase()
            .indexOf(this.searchInput.toLowerCase()) > -1
        );
      });
    } else {
      this.filteredData = this.markerClusterData;
    }
  }
}
